<template>
  <BModal
    id="modal-rules-face-detection"
    ref="modal-rules-face-detection"
    hide-header-close
    hide-footer
    hide-header
    :centered="true"
  >
    <div class="flex flex-col text-black gap-4 p-1">
      <div class="flex flex-col justify-center items-center text-center gap-4">
        <img
          src="https://storage.googleapis.com/komerce//camera-group.svg"
          alt="Komerce"
          width="50"
        >
        <div class="text-xl font-medium">
          Verifikasi Wajah
        </div>
        <div>
          Kami perlu memverifikasi bahwa Kamu adalah orang asli. Ikuti instruksi di layar untuk menyelesaikan verifikasi.
        </div>
      </div>
      <div>
        <span class="font-bold">Kamu akan diminta untuk:</span>
        <li
          v-for="(rule, idx) of rules"
          :key="idx"
          class="ml-1"
        >
          {{ rule }}
        </li>
      </div>
      <BButton
        block
        variant="primary"
        @click="$emit('start-verification')"
      >
        Mulai Verifikasi
      </BButton>
    </div>
  </BModal>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        'Putar Kepala ke Arah Kanan', 'Putar Kepala ke Arah Kiri', 'Senyum Saat Swafoto',
      ],
    }
  },
}
</script>
<style scoped>
li::marker {
  color: #F95031;
}
</style>
